import { API_URL as apiUrl } from "@/utils/data-provider";
import { RestDataProvider } from "./data-provider/provider";

// Helper function to get presigned URL for a media type
export const getPresignedUrl = async (media: File) => {

    const { data } = await RestDataProvider(apiUrl).custom({
        url: "/spaces-presigned-url",
        method: "post",
        payload: {
            content_type: media.type,
            resource_type: media.type.startsWith('image') ? 'image' : 'video',
            filename: media.name
        },
    });
    return data;
};